// extracted by mini-css-extract-plugin
module.exports = {"icon":"CopyLinkButton__icon--1eHBc","bounce":"CopyLinkButton__bounce--1q25P"};